<div class="form-section__body grid">
    <ng-content></ng-content>
</div>
